import React from 'react';
import { DEFAULT_PAGE_SIZE, fetchCatalogItems } from '@services/fmdc';
import { CATALOG_STATUS_FILTERS } from './fmdcUrl';

// The catalog items for one page of the URL's filters. Refetches when a server-side filter or the
// offset changes; `reload` refetches in place after a write. `enabled` lets the catalog page leave
// the items alone while the proposals tab is up.
export const useCatalogItems = (filters, { enabled = true } = {}) => {
  const [items, setItems] = React.useState(null);
  const [total, setTotal] = React.useState(0);
  const [error, setError] = React.useState(null);
  const [tick, setTick] = React.useState(0);

  const { q, section, status, offset } = filters;

  React.useEffect(() => {
    if (!enabled) return undefined;
    const state = { isCanceled: false };
    const run = async () => {
      const result = await fetchCatalogItems({
        q: q || undefined,
        section: section || undefined,
        status: status === CATALOG_STATUS_FILTERS.ALL ? undefined : status,
        limit: DEFAULT_PAGE_SIZE,
        offset,
      });
      if (state.isCanceled) return;
      if (result.error) {
        setError(result.error);
        // Keep the current page on a transient error rather than blanking the table.
        setItems((prev) => prev || []);
      } else {
        setError(null);
        setItems(result.items);
        setTotal(result.total);
      }
    };
    run();
    return () => {
      state.isCanceled = true;
    };
  }, [enabled, q, section, status, offset, tick]);

  const reload = React.useCallback(() => setTick((t) => t + 1), []);

  return { items, total, isLoading: items === null, error, reload };
};
